import { Fragment } from 'react';

import { Image, View } from '@react-pdf/renderer';
import { SmallHeading } from 'PDF/components/SmallHeading';

import { emptyChart, IImageChart } from '../types';

interface IChartPdfImagesGroup {
  images?: IImageChart[];
  heading?: string;
  headingProps?: { withBottomMargin?: boolean };
}

export const ChartPdfImagesGroup = ({
  heading = '',
  images,
  headingProps = {},
}: IChartPdfImagesGroup) => {
  if (!images) {
    return <></>;
  }
  const firstImage = images[0];
  const otherImages = images.slice(1);

  const currentFirstTitle = firstImage?.title || '';
  const currentFirstSubtitle = firstImage?.subTitle || '';

  return (
    <>
      <View wrap={false}>
        {Boolean(heading) && <SmallHeading heading={heading} {...headingProps} />}
        <>
          {Boolean(firstImage?.src) && firstImage.src !== emptyChart && (
            <View
              key={firstImage.src}
              wrap={false}
              style={{
                marginBottom: 30,
              }}
            >
              {Boolean(currentFirstTitle) && <SmallHeading heading={currentFirstTitle} {...headingProps} />}
              {Boolean(currentFirstSubtitle) && <SmallHeading heading={currentFirstSubtitle} {...headingProps} />}
              <Image src={firstImage.src} />
            </View>
          )}
        </>
      </View>
      {otherImages.map(({ title, src, subTitle }) => {
        const currentTitle = title || '';
        const currentSubtitle = subTitle || '';

        return (
          <Fragment key={src}>
            {Boolean(src) && src !== emptyChart && (
              <View
                key={src}
                wrap={false}
                style={{
                  marginBottom: 30,
                }}
              >
                {Boolean(currentTitle) && <SmallHeading heading={currentTitle} {...headingProps} />}
                {Boolean(currentSubtitle) && <SmallHeading heading={currentSubtitle} {...headingProps} />}
                <Image src={src} />
              </View>
            )}
          </Fragment>
        );
      })}
    </>
  );
};
